import React, { useState } from 'react';
import { FiBookOpen, FiChevronDown, FiChevronUp } from 'react-icons/fi';

const storageKey = (tab) => `slotSettings.guide.${tab}.hidden`;

const readHidden = (tab) => {
    try {
        return window.localStorage.getItem(storageKey(tab)) === '1';
    } catch (e) {
        return false;
    }
};

const writeHidden = (tab, hidden) => {
    try {
        window.localStorage.setItem(storageKey(tab), hidden ? '1' : '0');
    } catch (e) {
        // Storage can be blocked (private mode); the guide just stays open next time.
    }
};

const TabGuide = ({ tab, title, intro, steps = [], examples = [], note }) => {
    const [hidden, setHidden] = useState(() => readHidden(tab));

    const toggle = () => {
        setHidden(!hidden);
        writeHidden(tab, !hidden);
    };

    return (
        <section className={`ss-guide ${hidden ? 'is-collapsed' : ''}`} aria-label={`How to use ${title}`}>
            <button type="button" className="ss-guide-head" aria-expanded={!hidden} onClick={toggle}>
                <span className="ss-guide-icon"><FiBookOpen /></span>
                <span className="ss-guide-heading">
                    <span className="ss-guide-title">How to use: {title}</span>
                    <span className="ss-guide-intro">{intro}</span>
                </span>
                <span className="ss-guide-toggle">
                    {hidden ? 'Show guide' : 'Hide guide'} {hidden ? <FiChevronDown /> : <FiChevronUp />}
                </span>
            </button>
            {!hidden && (
                <div className="ss-guide-body">
                    {steps.length > 0 && (
                        <div>
                            <div className="ss-guide-label">Steps</div>
                            <ol className="ss-guide-steps">
                                {steps.map(step => <li key={step}>{step}</li>)}
                            </ol>
                        </div>
                    )}
                    {examples.length > 0 && (
                        <div>
                            <div className="ss-guide-label">Examples</div>
                            <ul className="ss-guide-examples">
                                {examples.map(example => (
                                    <li key={example.task}>
                                        <span className="ss-guide-task">{example.task}</span>
                                        <span className="ss-guide-how">{example.how}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {note && <div className="ss-guide-note">{note}</div>}
                </div>
            )}
        </section>
    );
};

export default TabGuide;
